import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ParticipantsPluginService } from './participants-plugin.service';

@Component({
    templateUrl: './participants.component.html',
    standalone: false
})
export class ParticipantsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public participants: any[];
  public inspection: Inspection;

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private service: ParticipantsPluginService
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();

    if (!this.plugin.config.Participants) return;

    this.participants = this.plugin.config.Participants.filter((p) => p.Name).sort((a, b) => {
      const nameA = a.Name.toUpperCase();
      const nameB = b.Name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    // this.plugin.config.Participants;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'participants',
      'edit'
    ];
  }
}

PluginComponent.plugins['participants'] = ParticipantsPluginComponent;
